<template>
    <v-dialog v-model="dialog" max-width="900">
        <v-card>
            <v-card-title class="headline">{{ 'app.subscriptions' | trans}}</v-card-title>
            <v-card-text>
                <subscription-manage-dialog
                    ref="subscriptionManageDialog"
                    @subscription_stored="onSubscriptionStored()"
                    @subscription_closed="modalClosed()"
                    :currentSubscription="currentSubscription"
                />
                <v-data-table
                        :disable-initial-sort="true"
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pagination"
                        :total-items="total"
                        :loading="isLoading"
                        :rows-per-page-items="[10,25,50,100]"
                        :no-data-text="trans('app.search.no_data')"
                >
                    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td class="text-xs-center">
                                {{ props.item.start_date | format_date(FORMAT_DATE) }}
                            </td>
                            <td class="text-xs-center">
                                {{props.item.end_date | format_date(FORMAT_DATE)}}
                            </td>
                            <td class="text-xs-center">
                                {{props.item.subscription_type.name}}
                            </td>
                            <td class="text-xs-center">
                                {{ props.item.created_at | format_date(FORMAT_DATETIME_SECONDS) }}
                            </td>
                            <td class="justify-end layout px-0 pr-4">
                              <v-tooltip top>
                                <template #activator="{ on }">
                                  <v-btn
                                      v-on="on"
                                      flat
                                      icon
                                      color="green"
                                      class="mr-0 ml-0"
                                      @click="editItem(props.item)">
                                    <v-icon small>edit</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ 'app.edit' | trans }}</span>
                              </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2 pb-4">
                    <v-pagination v-model="pagination.page" total-visible=10 :length="pages"></v-pagination>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import {trans} from "../../../app";
    import {stringify} from "qs";
    import {FORMAT_DATE, FORMAT_DATETIME_SECONDS} from "../../../utils/dateFormatter";

    export default {
        props: {
            user_id: {
                type: Number,
                default: null,
            },
            dialog: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            headers: [
                {
                    text: trans('app.start_date'), align: 'center', value: 'start_date', sortable: false,
                },
                {
                    text: trans('app.end_date'), align: 'center', value: 'end_date', sortable: false,
                },
                {
                    text: trans('app.subscription_type'),
                    align: 'center',
                    value: 'subscription_type_id',
                    sortable: false,
                },
                {
                    text: trans('app.createdAt'), align: 'center', value: 'created_at', sortable: false,
                },
                {
                  text: '', align: 'center', sortable: false,
                },
            ],
            items: [],
            pages: 0,
            isLoading: true,
            pagination: {},
            total: 0,
            currentSubscription: null,
            FORMAT_DATETIME_SECONDS: FORMAT_DATETIME_SECONDS,
            FORMAT_DATE: FORMAT_DATE
        }),
        methods: {
          trans,
            async fetchData() {
                this.isLoading = true;
                const {sortBy, descending, page, rowsPerPage} = this.pagination;

                const query = {
                    page: page,
                    perPage: rowsPerPage,
                    orderBy: sortBy,
                    dir: descending ? 'asc' : 'desc',
                    user_id: this.user_id,
                };

                const response = await axios.get(`/administrator/subscriptions?${stringify(query, {skipNulls: true})}`);

                const {data, meta} = response.data;

                this.items = data;
                this.total = meta.total;
                this.pages = meta.last_page;
                this.isLoading = false;
            },
            editItem(item) {
                this.currentSubscription = item;
                this.$refs.subscriptionManageDialog.open();
            },
            modalClosed() {
              this.currentSubscription = null;
            },
            onSubscriptionStored() {
              this.fetchData();
            }
        },
        watch: {
            dialog(value) {
                if (value === true) {
                    this.fetchData();
                }

                if (value === false) {
                    this.$emit('closed');
                }
            },
            pagination: {
                handler() {
                    if (this.user_id) {
                        this.fetchData();
                    }
                },
                deep: true,
            },
        },
    };
</script>
